module.exports = require('./helpers/bundle-url').getBundleURL('7R2cq') + "logo-dark.eefe0b7f.svg";